// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../../utilities/encryptedBaseQuery";

// Define a service using a base URL and expected endpoints
export const termsApi = createApi({
  reducerPath: "termsApi",
  baseQuery: encryptedBaseQueryWithReauth(),
  tagTypes: ["getTermsList"],
  endpoints: (builder) => ({
    getTermsList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getTermsList"],
    }),

    getSingleTerms: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
    getListData: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),

    getEntityList: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),

    deleteTerms: builder.mutation({
      query: (endpoint) => ({
        url: `${endpoint}`,
        method: "DELETE",
      }),
      invalidatesTags: ["getTermsList"],
    }),

    addTerms: builder.mutation({
      query: ({ endpoint, data }) => ({
        url: endpoint,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["getTermsList"],
    }),

    updateTerms: builder.mutation({
      query: ({ endpoint, data }) => ({
        url: endpoint,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["getTermsList"],
    }),
  }),
});

export const {
  useGetTermsListQuery,
  useGetSingleTermsQuery,
  useDeleteTermsMutation,
  useAddTermsMutation,
  useUpdateTermsMutation,
  useGetListDataQuery,
  useGetEntityListQuery,
} = termsApi;
